import clsx from 'clsx';
import * as React from 'react';
import { ReactElement } from 'react';

import { BaseIcon } from '@/shared/components/atoms/IconButton/BaseIcon';
import { IPagination } from '@/shared/components/atoms/Pagination/IPagination';
import range from '@/shared/components/atoms/Pagination/logic';
import { Typography } from '@/shared/components/atoms/Typography';

import Arrow from '~/images/shared/leftArrow.svg';

export default function Pagination({
  currentPage = 0,
  totalCount = 0,
  perPage = 1,
  onPageChange,
}: IPagination): ReactElement {
  const firstPage = Math.max(1, currentPage - 3);
  const lastPage = Math.min(currentPage + 3, Math.ceil(totalCount / perPage));

  const goToNextPage = (): void => {
    onPageChange(Math.min(currentPage + 1, Math.ceil(totalCount / perPage)));
  };
  const goToPreviousPage = (): void => {
    onPageChange(Math.max(currentPage - 1, 1));
  };

  return totalCount > perPage ? (
    <ul className='m-auto flex items-center gap-2'>
      <button
        disabled={currentPage <= firstPage}
        onClick={goToPreviousPage}
        className={clsx(
          'cursor-pointer  rounded-full  bg-primary-default p-6 disabled:bg-background-disable'
        )}
      >
        <BaseIcon size='xxs' svgClasses='rtl:rotate-180 text-white'>
          <Arrow />
        </BaseIcon>
      </button>
      {range(firstPage, lastPage).map(
        (page: number): JSX.Element => (
          <li
            aria-current={page === currentPage ? 'page' : undefined}
            key={page}
          >
            <button onClick={() => onPageChange(page)}>
              <Typography
                variant='body2'
                className={clsx(
                  page === currentPage
                    ? 'font-bold text-primary-default'
                    : 'text-background-disable'
                )}
              >
                {page}
              </Typography>
            </button>
          </li>
        )
      )}
      <button
        disabled={currentPage >= lastPage}
        onClick={goToNextPage}
        className={clsx(
          'cursor-pointer  rounded-full  bg-primary-default p-6 disabled:bg-background-disable'
        )}
      >
        <BaseIcon size='xxs' svgClasses='ltr:rotate-180 text-white'>
          <Arrow />
        </BaseIcon>
      </button>
    </ul>
  ) : (
    <></>
  );
}
